import React from 'react';
import { TYPES_OF_ZAKAT } from '../../../common/images-svg';

class FlickeringTypeOfZakat extends React.Component {
    render() {
        const types = [
            { name: 'Savings' },
            { name: 'Gold' },
            { name: 'Insurance' },
            { name: 'Shares' },
            { name: 'Business' },
        ];

        return (
            <div className='fleckring-effect'>
                <div className='row row-type header'>
                    <div className='col-md-1 c-icon'>
                        &nbsp;
                    </div>
                    <div className='col-md-4 c-type-zakat'>
                        TYPE OF ZAKAT
                    </div>
                    <div className='col-md-4 c-source'>
                        SOURCE OF INCOME
                    </div>
                    <div className='col-md-3 c-amt'>
                        AMOUNT
                    </div>
                </div>
                <div className='c-body'>
                    <form className="form">
                        {types.map((type, index) => {
                            return (
                                <div className='row row-type' key={index}>
                                    <div className='col-md-1 c-icon'>
                                        {TYPES_OF_ZAKAT[type.name.trim().replace(/\s+/g, '_').toLowerCase()]}
                                    </div>
                                    <div className='col-md-4 c-type-zakat'>
                                        {type.name}
                                    </div>
                                    <div className='col-md-4 form-group c-source'>
                                        <div className='box W130x40'>&nbsp;</div>
                                    </div>
                                    <div className='col-md-3 form-group c-amt'>
                                        <div className='box W130x40'>&nbsp;</div>
                                    </div>
                                </div>
                            )
                        })}
                    </form>
                </div>
            </div>
        )
    }
}

export default FlickeringTypeOfZakat;